// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * fix-sprint-20260912-2123 F28 — ONE declaration of this contract.
 *
 * Until this change the vocabulary existed twice: as a hand-written union here,
 * which the frontend types against, and as an `as const` array in
 * `product-classification-service.ts`, which `z.enum(...)` validates against and
 * which the server serves. Only the backend copy had a runtime array, so the two
 * could not be checked against each other and had already drifted (the backend
 * record carried `org_id`; this one did not declare it). Adding a member here
 * compiled clean while the route rejected it with 400; adding one there let an
 * undeclared value through the page's `as ProductDetermination` cast.
 *
 * The arrays are the declaration and the unions are derived from them, so the
 * validator and the type can no longer disagree: a member added here reaches
 * `z.enum` in the same commit. The backend extends the record with `org_id`
 * rather than restating it.
 */
export const PRODUCT_DETERMINATIONS = [
    'not_determined',
    'recorded_in_scope',
    'recorded_excluded',
    'dual_use_referral',
];
export const THREE_PART_DETERMINATIONS = ['not_determined', 'matched', 'not_matched'];
export const CIRCULATION_EVIDENCE_STATES = ['evidenced', 'not_evidenced', 'expired'];
/**
 * fix-sprint-20260912-2123 F16 — the register surfaces the product-assurance
 * registers discover their installed content by.
 *
 * These are PLATFORM vocabulary (a form template's `register_surface`), not an
 * instrument, authority or country term, so they are declarable in `src/`
 * (R-46). They are exported because this register's framework scope is derived
 * from installed FORM TEMPLATES carrying these surfaces — unlike every other
 * boundary reader, whose scope comes from a deadline `event_type` — and the
 * pack-corpus guard must join on the same thing the service does rather than
 * on a string it remembers.
 */
export const PRODUCT_CLASSIFICATION_REGISTER_SURFACE = 'product_classification';
export const DUAL_USE_REFERRAL_REGISTER_SURFACE = 'dual_use_referral';
export const CONFORMITY_CERTIFICATE_REGISTER_SURFACE = 'conformity_certificate';
//# sourceMappingURL=product-assurance.js.map